import { Avatar, Flex, View } from '@adobe/react-spectrum';
import styles from './card_component.module.css';
import { truncateText } from '../../../../utils/helperUtil';
import { ChevronRight } from 'react-bootstrap-icons';

interface ICardComponentProps {
  item: any;
}

const CardComponent: React.FC<ICardComponentProps> = ({ item }) => {
  const docNo = item.refId || item.ident || '-';
  const displayName = item.creatorName || item.userName || item.solver || '-';
  const accentColor = item.entryTypeColor || item.statusColor;

  return (
    <Flex direction="column" position={'absolute'} width={'100%'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.card_list}>
      <Flex direction={'row'} position={'relative'} width={'100%'} alignItems={'center'} justifyContent={'start'} UNSAFE_className={styles.card_child_wrapper}>
        <View
          position={'absolute'}
          margin={'0px'}
          height={'calc(100% - 36px)'}
          width={'4px'}
          top={'18px'}
          bottom={'18px'}
          left={'-1px'}
          maxHeight={'100%'}
          zIndex={1}
          UNSAFE_style={{ backgroundColor: accentColor, borderRadius: '3px' }}
        />
        <Flex direction={'column'} width={'100%'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'10px'} zIndex={1}>
          <Flex direction={'column'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} gap={'12px'}>
            <Flex direction={'row'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'space-between'} gap={'8px'}>
              <View flex={1} position={'relative'} UNSAFE_className={styles.heading_text}>
                {truncateText(item.title, 30)}
              </View>
              <View position={'relative'} UNSAFE_className={styles.heading_date}>
                {item.createdDisplay || item.deadLine || '-'}
              </View>
            </Flex>
            <Flex direction={'row'} alignItems={'center'} justifyContent={'start'} gap={'6px'} UNSAFE_className={styles.header_path_wrapper}>
              <View position={'relative'} UNSAFE_className={styles.header_path_text}>
                <span title={`${item.folderName} > ${item.projectName}`}>
                  {truncateText(item.folderName, 25)} {item.project && <ChevronRight size={12} />} {truncateText(item.projectName, 25)}
                </span>
              </View>
            </Flex>
          </Flex>
          <View position={'relative'} alignSelf={'stretch'} height={'1px'} UNSAFE_className={styles.header_divider}>
          </View>
          <Flex direction={'row'} width={'100%'} alignItems={'stretch'} justifyContent={'space-between'} gap={'6px'}>
            <View UNSAFE_style={{ fontSize: '16px' }}><Avatar src='/assets/images/avatar--desktop--light@2x.png' />  {displayName}</View>
            <View UNSAFE_style={{ fontSize: '14px', marginTop: '5px' }}>{docNo}</View>
          </Flex>
        </Flex>
      </Flex>
      <View UNSAFE_style={{ height: '10px' }} />
    </Flex>
  );
};

export default CardComponent;
